export default __webpack_public_path__ + "static/media/mark_email_read_black_24dp.74418ed0.svg";